import { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import { withRouter, Link } from "react-router-dom";
import * as act from "../../Store/actions"
import * as com from "../../Common"
import { Button, Col, Row, Tooltip, Input } from 'antd';
import EmailVerification from '../../Application/EmailVerification';
import { CalcHardMoneyLoanRate } from './Utils';
import "./loanRateResult.css";
import {
  QuestionCircleFilled,
  InfoCircleFilled
} from '@ant-design/icons';
import { totalmem } from 'os';

const eligibleCities = ["Fremont", "Newark", "Union City", "Pleasanton", "Dublin", "Livermore", "San Ramon", "Danville"]
const eligibleCounties = ["Santa Clara County", "San Mateo County"]

const mapStateToProps = (state) => {
  return {
      application: state.application,
      progress: state.progress,
  }
}

const mapDispatchToProps = (dispatch) => ({
  changeMainPropertyAttribute: (t, verb) => {
      dispatch(act.ChangeMainPropertyAttribute(t, verb))
  },
  changeBorrowerInfo: (event, verb) => {
      dispatch(act.ChangeBorrowerInfo(event, "borrower", verb))
  },
  updateChangeApplication: (application) => {
      dispatch(act.updateApplication(application))
  },
});

const LoanRateResult = (props) => {
  const { signUpOnly } = props
  const [showSignup, setShowSignup] = useState(false)
  const [showEmailVerification, setShowEmailVerification] = useState(false)
  const [rate, setRate] = useState("")
  const [maxLoanAmount, setMaxLoanAmount] = useState("")
  const [totalLoanAmount, setTotalLoanAmount] = useState("")
  const [initialLoanAmount, setInitialLoanAmount] = useState("")
  const [rehabLoanAmount, setRehabLoanAmount] = useState("")
  const [cashoutAmount, setCashoutAmount] = useState("")
  const [constructionLoanAmount, setConstructionLoanAmount] = useState("")
  const [interestReservesAmount, setInterestReservesAmount] = useState("")
  const [showContruction, setShowContruction] = useState(false)
  const [showCashout, setShowCashout] = useState(false)
  const [bridgeOnly, setBridgeOnly] = useState(false)
  const [monthlyPayment, setMonthlyPayment] = useState("")
  const [closingCost, setClosingCost] = useState("")
  const [unqualified, setUnqualified] = useState(false)
  const [unqualifiedReason, setUnqualifiedReason] = useState("")
  const [finalLtaiv, setFinalLtaiv] = useState(0)
  const [finalLtc, setFinalLtc] = useState(0)
  const [finalLtarv, setFinalLtarv] = useState(0)
  const [capRatio, setCapRatio] = useState("")
  const [originationFee, setOriginationFee] = useState(0)
  const [underwritingFee, setUnderwritingFee] = useState(0)
  const [cashToClose, setCashToClose] = useState(0)

  const cardList = [

    {
        title: 'Total Loan Amount',
        value: totalLoanAmount
    },
    {
      title: 'Initial Loan Amount',
      value: initialLoanAmount
    },
    {
      title: 'Rehab Loan Amount',
      value: rehabLoanAmount
    },
    {
      title: 'Cashout Amount',
      value: cashoutAmount
    },
    {
      title: 'Construction Loan Amount',
      value: constructionLoanAmount
    },
    {
      title: 'Interest Reserves',
      value: interestReservesAmount
    },
    {
        title: 'Interest Rate',
        value: rate
    },
    {
        title: 'Monthly Payment',
        value: monthlyPayment
    },
    {
        title: 'Cash to Close',
        value: closingCost
    }
  ]

  const cardListOnLanding = [
    {
      title: 'Total Loan Amount',
      value: totalLoanAmount
    },
    {
      title: 'Initial Loan Amount',
      value: initialLoanAmount
    },
    {
      title: 'Rehab Loan Amount',
      value: rehabLoanAmount
    },
    {
      title: 'Interest Rate',
      value: rate
    },
    {
      title: 'Monthly Payment',
      value: monthlyPayment
    },
    {
      title: 'Cash to Close',
      value: closingCost
    }
  ]

  const cardListForRatios = [
    {
      title: 'LTAIV',
      value: finalLtaiv
    },
    {
      title: 'LTC',
      value: finalLtc
    },
    {
      title: 'LTARV',
      value: finalLtarv
    }
  ]

  useEffect(()=>{
    let result = CalcHardMoneyLoanRate(props)
    setRate(result.floorRate.toFixed(3) + "%")
    setMonthlyPayment("$" + com.commaize(result.monthlyPayment))
    setClosingCost("$" + com.commaize(result.closingCost))
    setUnqualified(result.unqualified)
    setUnqualifiedReason(result.unqualifiedReason)
    setTotalLoanAmount("$"+ com.commaize(result.totalLoanAmount))
    setInitialLoanAmount("$"+ com.commaize(result.initialLoanAmount))
    setRehabLoanAmount("$"+ com.commaize(result.rehabLoanAmount))
    setCashoutAmount("$"+ com.commaize(result.cashoutAmount))
    setConstructionLoanAmount("$"+ com.commaize(result.constructionLoanAmount))
    setInterestReservesAmount("$"+ com.commaize(result.interestReservesAmount))
    setShowContruction(result.showContruction)
    setShowCashout(result.showCashout)
    setBridgeOnly(result.bridgeOnly)
    setFinalLtaiv(result.ltaiv)
    setFinalLtc(result.ltc)
    setFinalLtarv(result.ltarv)
    setCapRatio(result.capRatio)
    setOriginationFee(result.originationFee)
    setUnderwritingFee(result.underwritingFee)
    setCashToClose(result.cashtoclose)
    console.log("on props update")
  }, [props.application, props.rehabBudget, props.interestReserves, props.landEntitlement, props.costToDate, props.monthFromPurchase, props.cashoutAmount])

  const back = (type) => {
    if (type === 1) {
      setShowEmailVerification(false)
    }
  }

  const signup = () => {
    if (showEmailVerification) {
      return (
        <div style={{padding: '50px 0'}}>
          <EmailVerification purpose="hardmoneyloan" back={(type) => back(type)} customerid={props.customerid} />
        </div>
      )
    }
    return (
      <div className='creat-account'>
        <div className='creat-title'>Create Account</div>
        <div className='creat-subtitle'>To explore your best loan option and get connected with our experienced loan officers </div>
        <Row gutter={20}>
          <Col style={{marginBottom: '20px'}} sm={12} span={24}><Input size="large" placeholder="First name" onChange={(e)=> props.changeBorrowerInfo(e.target.value, "firstname")}/></Col>
          <Col style={{marginBottom: '20px'}} sm={12} span={24}><Input size="large" placeholder="Last name" onChange={(e)=> props.changeBorrowerInfo(e.target.value, "lastname")}/></Col>
        </Row>
        <Row>
          <Col span={24}><Input size="large" placeholder='Email'onChange={(e)=> props.changeBorrowerInfo(e.target.value, "email")}/></Col>
        </Row>
        <div><Button className='continue-btn' type="primary" onClick={()=>setShowEmailVerification(true)}>Continue</Button></div>
        {!signUpOnly && <div className='to-login'><span>Already have an account?</span> <Link to={"/services/signin?customerid=" + props.customerid}>Log in</Link></div>}
        {!signUpOnly && <div className='to-login mt-3'> <a className='text-blue ' onClick={()=>setShowSignup(false)}>Go back</a></div>}
      </div>
    )
  }

  const showUnqualified = () => {
    return <div className='mb-5'>
      <div className='bold mb-2'>Sorry, we are unable to offer a loan based on the input provided. This is due to:</div>
      <div style={{fontSize: 20, fontWeight: 500}}>{unqualifiedReason}</div>
    </div>
  }

  return (
    <div className='loan-rate-result center' style={{paddingTop: signUpOnly ? '100px' : '0px'}}>
      {signUpOnly || showSignup ? signup() : <div>
      <div className='title center'>Fill in the table on the left and click <span className='bold'>Calculate</span> to see your rates</div>
      <div className='title center big-title'>Pre-approved Loan Details</div>
      <Row className='result-card'>
        {
          !props.showResult ? (
            <>
              <Row>
                {cardListOnLanding.map((item, index) =>
                  <Col span={24} sm={12} className='card-item center' key={index}>
                    <div className='result-title'>{item.title}</div>
                    <div className='result-value'>---</div>
                  </Col>
                )}
                {cardListForRatios.map((item, index) =>
                  <Col span={24} sm={8} md={12} className='card-item center' key={index}>
                    <div className='result-title'>{item.title}</div>
                    <div className='result-value'>---</div>
                  </Col>
                )}
              </Row>
              {/* <Row className="ratios-row">
                {cardListForRatios.map((item, index) =>
                  <Col span={24} sm={8} md={12} className='card-item center' key={index}>
                    <div className='result-title'>{item.title}</div>
                    <div className='result-value'>---</div>
                  </Col>
                )}
              </Row> */}
            </>
          ):(
            unqualified ? showUnqualified() : 
            <>
              <Row >
                {cardList.map((item, index) => {
                    if (item.title === "Cashout Amount" && !showCashout) {
                    return null
                  }
                  if ((item.title === "Construction Loan Amount" || item.title === "Interest Reserves") && !showContruction) {
                    return null
                  }
                  if (item.title === "Rehab Loan Amount" && showContruction) {
                    return null
                  }
                  if ((item.title === "Rehab Loan Amount" || item.title === "Construction Loan Amount") && bridgeOnly) {
                    return null
                  }
                  return (
                    <Col span={24} sm={12} className='card-item center' key={index}>
                      <div className='result-title'>{item.title}</div>
                      <div className='result-value'>
                        {item.title === "Cash to Close" ?
                          <div>
                            <Tooltip
                              rootClassName='tip-text-tooltip'
                              title={
                                <div className='tip-text-tooltip-content'>
                                  <div>Origination Fee:</div>
                                  <div className='mb-2'>${com.commaize(originationFee)}</div>
                                  <div>Underwriting Fee:</div>
                                  <div className='mb-2'>${com.commaize(underwritingFee)}</div>
                                  <div>Out of pocket:</div>
                                  <div className='mb-2'>${com.commaize(cashToClose)}</div>
                                </div>
                              }
                            >
                              <div className='tip-text'>{item.value}</div>
                            </Tooltip>
                          </div>
                          :
                          item.value
                      }
                      </div>
                    </Col>
                  )
                })}
                {cardListForRatios.map((item, index) =>
                  <Col span={24} sm={8} md={12} className='card-item center' key={index}>
                    <div className='result-title'>{capRatio === item.title ? item.title +" (*cap)" : item.title}</div>
                    <div className={capRatio === item.title ? 'result-value-highlight' : 'result-value'}>{item.value}%</div>
                  </Col>
                )}
              </Row>
              {/* <Row className="ratios-row">
                {cardListForRatios.map((item, index) =>
                  <Col span={24} sm={8} md={12} className='card-item center' key={index}>
                    <div className='result-title'>{item.title}</div>
                    <div className='result-value'>{item.value}%</div>
                  </Col>
                )}
              </Row> */}
            </>
          )
        }
      </Row>
      <div className='center result-disclaimer'>*Monthly payment is estimated based on the total loan amount. Actual interest payments may vary depending on the draw schedule.</div>
      <div className='center result-disclaimer'>*The final loan amount will be determined based on the appraised value provided by an authorized third-party appraiser.</div>
      <div className='describe info-first center'>To obtain an accurate rate tailored to your specific situation, simply sign up below. </div>
      <div className='describe info-second center'>Our experienced loan officers will promptly reach out to assist you in finding the best rate available.</div>
      <div className='btn-wrap center'><Button className="sign-btn" type="primary" onClick={()=>setShowSignup(true)}>Sign Up</Button></div>
      <div className='login center'>Already have an account? <span className='text-blue'><Link to={"/services/signin?customerid=" + props.customerid}>Login</Link></span></div>
      {/* <div className='privacy center'>Privacy Statement</div> */}
    </div>}
    
    </div>
  );
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(LoanRateResult))
